import React from "react";

/**
 * Page loader - full page centered spinner (for initial page load).
 */
export const PageLoader = ({ text = "Loading..." }) => (
  <div className="flex flex-col items-center justify-center min-h-[400px]">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4" />
    <p className="text-sm text-text-secondary">{text}</p>
  </div>
);

/**
 * Inline loader - displays in list/content area (no overlay, no modal).
 * Use where the list/table content would appear.
 */
export const InlineLoader = ({ text = "Loading...", size = "medium" }) => {
  const sizeClass = size === "small" ? "h-8 w-8" : size === "large" ? "h-12 w-12" : "h-10 w-10";
  return (
    <div className="flex flex-col items-center justify-center py-12 sm:py-16 px-4">
      <div className={`animate-spin rounded-full border-b-2 border-primary ${sizeClass} mb-3`} />
      <p className="text-sm text-text-secondary">{text}</p>
    </div>
  );
};

export default PageLoader;
